<template>
    <modal :show.sync=show modalClasses="medium-sized-modal modal-hide-footer">
        <h3 slot="header" class="mb-0 font-weight-500">Create Hub</h3>
        <ValidationObserver v-slot="{ invalid }" ref="observer">
            <b-form ref="hubForm" role="form" @submit.prevent="submit()">
                <b-row>
                    <b-col cols="12">
                        <b-form-group>
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'hubType'"
                            >
                                <el-radio-group v-model="form.type">
                                    <el-radio :label="1" style="line-height: 0;">
                                        <b-iconstack font-scale="2" style="vertical-align: middle;">
                                            <b-icon stacked icon="square-fill" variant="success"></b-icon>
                                            <b-icon stacked icon="basket2" scale="0.5" class="text-white"></b-icon>
                                        </b-iconstack>
                                        <span style="vertical-align: middle;" class="mx-2 font-weight-400">Green Basket</span>
                                    </el-radio>
                                    <el-radio :label="2" style="line-height: 0;">
                                        <b-iconstack font-scale="2" style="vertical-align: middle;">
                                            <b-icon stacked icon="square-fill" style="color: #f2a818 !important"></b-icon>
                                            <b-icon stacked icon="basket2" scale="0.5" class="text-white"></b-icon>
                                        </b-iconstack>
                                        <span style="vertical-align: middle;" class="mx-2 font-weight-400">Yellow Basket</span>
                                    </el-radio>
                                </el-radio-group>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-form-group label="Hub Name">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true, name: true }"
                                :vid="'hubName'"
                            >
                                <b-form-input
                                v-model="form.name"
                                placeholder="Enter Hub Name"
                                required
                                ></b-form-input>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-form-group label="Hub Manager">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'hubManager'"
                            >
                                <el-select v-model="form.hub_manager" filterable placeholder="Select Hub Manager">
                                    <el-option v-for="option in selectHubManagerOptions"
                                        :key="option.id"
                                        :label="option.name"
                                        :value="option.id">
                                    </el-option>
                                </el-select>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group> 
                    </b-col>
                    <b-col cols="12">
                        <b-form-group label="Hub Address">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'hubTarget'"
                            >
                                <b-form-textarea
                                v-model="form.address"
                                rows="3"
                                required
                                ></b-form-textarea>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-form-group label="Target Revenue Point (RM):">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true, currency: true }"
                                :vid="'hubTarget'"
                            >
                                <b-form-input
                                    v-model="form.target"
                                    placeholder="Enter target"
                                    type="text"
                                    required
                                ></b-form-input>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6" cols="12" class="mx-auto text-center mt-4 pt-2">
                        <b-button type="submit" class="w-100" variant="primary" :disabled="invalid">Create</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </ValidationObserver>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option, Radio, RadioGroup } from 'element-ui'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import '@/assets/js/formValidations.js'
import {axios, services, getHeader } from '@/assets/js/httpImports.js'
import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js'
import { EventBus } from '../../../../../main'

export default {
    props:{
        show_new_hub: Boolean
    },
    mixins: [notifyFunctionMixin],
    components: {
        ValidationObserver,
        ValidationProvider,
        Modal,
        [Select.name]: Select,
        [Option.name]: Option,
        [Radio.name]: Radio,
        [RadioGroup.name]: RadioGroup,
    },
    computed: {
        show: {
            get() {
                return this.show_new_hub;
            },
            set(newVal) {
                this.$emit('update:show_new_hub', newVal);
            },
        },
    },
    data(){
        return {
            form: {
                name: '',
                hub_manager: '',
                target: '',
                type: '',
                setting: {
                    max_hub_teams_number: '',
                    max_hub_team_members_number: '',
                },
            },
            selectTypeOptions: [],
            selectHubManagerOptions: [],
        }
    },
    created() {
        this.hubTypeList()
        this.hubManagerList()
    },
    methods: {
        hubTypeList() {
            axios.get(services.hub + 'setup/hub_type', { headers: getHeader() })
            .then(response => {
                this.selectTypeOptions = response.data.data
            })
            .catch ( error => {
                this.errorFunction(error, "Showing Hub Listing failed: " + error.response.data.message) 
            });
        },
        hubManagerList() {
            axios.get(services.access_control + 'user_list_by_role/hub manager', { headers: getHeader() })
            .then(response => {
                this.selectHubManagerOptions = response.data.data
            })
            .catch ( error => {
                this.errorFunction(error, "Showing Hub Listing failed: " + error.response.data.message) 
            });
        },
        submit() {
            let form = new FormData()
            form.append('user_id', this.form.hub_manager)
            form.append('hub_name', this.form.name)
            form.append('hub_address', this.form.address)
            form.append('hub_target', this.form.target)
            form.append('hub_type_id', this.form.type)

            axios.post(services.hub + 'hubs', form ,{ headers: getHeader() })
            .then ( response => {
                if (response.status === 200)
                {
                    // this.createHubSetting(response.data.data);
                    EventBus.$emit('refresh-hub-list',response)
                    this.$notify({
                        message:
                        '<b>New Hub : ' + response.data.data.hub_name + '</b> - Successfully Created.',
                        timeout: 10000,
                        icon: 'ni ni-bell-55',
                        type: 'default',
                    });
                }
            })
            .catch ( e => {
                this.errorFunction(e)
            });
        },
    }
}
</script>